// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore generated file
import translations from '../../../config/locales/compiled/translations-fr.json';
const parsedTranslations = JSON.parse(translations);

window.Greenhouse = window.Greenhouse || {};
window.Greenhouse.Translation = window.Greenhouse.Translation || {};
window.Greenhouse.Translation.translations = parsedTranslations;
